import React, { useMemo } from 'react'
import logoPng from 'images/logo.png'
import { useAppSelector } from 'application/core/domain/store/hooks'
import { getOutletAppliedParameter } from 'application/core/domain/useCase/outlets/outletActions'
import apiClient from 'application/core/data/apiClient/apiClient'

import s from './MainHeader.module.scss'

const Header = () => {
  const { outlet } = useAppSelector(({ userReducer }) => ({
    outlet: userReducer.outlet,
  }))

  const logoImage = useMemo(() => {
    const p = getOutletAppliedParameter(outlet, 'logo')
    return p?.value ? `${apiClient.defaults.baseURL}${p.value}` : logoPng
  }, [outlet])

  return (
    <div className={s.container}>
      <div className={s.logo}>
        <img src={logoImage} alt="" />
      </div>
    </div>
  )
}

export default React.memo(Header)
